import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/table
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import TableEditing from "./tableediting";
import TableUI from "./tableui";
import Widget from '@ckeditor/ckeditor5-widget/src/widget';
import "../theme/table.css";
/**
 * The table plugin.
 *
 * For a detailed overview, check the {@glink features/table Table feature documentation}.
 *
 * This is a "glue" plugin which loads the {@link module:table/tableediting~TableEditing table editing feature}
 * and {@link module:table/tableui~TableUI table UI feature}.
 *
 * @extends module:core/plugin~Plugin
 */

var Table = /*#__PURE__*/function (_Plugin) {
  _inherits(Table, _Plugin);

  var _super = _createSuper(Table);

  function Table() {
    _classCallCheck(this, Table);

    return _super.apply(this, arguments);
  }

  _createClass(Table, null, [{
    key: "requires",

    /**
     * @inheritDoc
     */
    get: function get() {
      return [TableEditing, TableUI, Widget];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'Table';
    }
  }]);

  return Table;
}(Plugin);
/**
 * The configuration of the table features. Used by the table features in the `@ckeditor/ckeditor5-table` package.
 *
 *		ClassicEditor
 *			.create( editorElement, {
 * 				table: ... // Table feature options.
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * See {@link module:core/editor/editorconfig~EditorConfig all editor options}.
 *
 * @interface TableConfig
 */

/**
 * The configuration of the {@link module:table/table~Table} feature.
 *
 * Read more in {@link module:table/table~TableConfig}.
 *
 * @member {module:table/table~TableConfig} module:core/editor/editorconfig~EditorConfig#table
 */


export { Table as default };